import { createFileRoute } from "@tanstack/react-router";
import { PortalFailuresV2Page } from "@/components/v2/pages/portal-failures-v2-page";

export const Route = createFileRoute("/portal/failures")({
  component: PortalFailuresV2Page,
});
